import { render, staticRenderFns } from "./ProjectDashboard.vue?vue&type=template&id=984e6182&scoped=true&"
import script from "./ProjectDashboard.vue?vue&type=script&lang=js&"
export * from "./ProjectDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDashboard.vue?vue&type=style&index=0&id=984e6182&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984e6182",
  null
  
)

export default component.exports